var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportActivIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16069 4.76243L12.7404 5.7162M8.39336 7.61007L10.1832 8.08692M8.48239 12.9748L9.19834 13.1656C11.2233 13.7051 12.2358 13.9749 13.0334 13.517C13.831 13.0591 14.1024 12.0523 14.6449 10.0387L15.4123 7.19112C15.9549 5.17755 16.2262 4.17077 15.7657 3.37763C15.3052 2.58448 14.2927 2.31472 12.2676 1.77519L11.5517 1.58443C9.52676 1.04489 8.51426 0.775134 7.71663 1.23306C6.91898 1.69098 6.64768 2.69776 6.10509 4.71132L5.33775 7.55892C4.79515 9.57245 4.52386 10.5793 4.98438 11.3724C5.44489 12.1656 6.45739 12.4354 8.48239 12.9748Z",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 15.2098L7.7858 15.4042C5.76554 15.9544 4.75543 16.2294 3.95965 15.7625C3.16389 15.2956 2.89322 14.2691 2.3519 12.216L1.58637 9.31257C1.04505 7.25951 0.774386 6.23297 1.23383 5.42427C1.63126 4.72472 2.50001 4.75019 3.62501 4.7501",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportActivIc);
export default __webpack_public_path__ + "static/media/reportActivIC.063fcc9156368897252f718f90566579.svg";
export { ForwardRef as ReactComponent };